import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Footer from "../components/footer";

import Form from "../components/shipping/form";

export default class Shipping extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            banners: [],
            error: null,
        }
    }

    
    render() {
        return (
            <div>
                <Header/>
                <Form/>
                <Float/>
                <Footer/>
            </div>
        );
    }

}

if (document.getElementById('content_shipping')) {
    ReactDOM.render(<Shipping />, document.getElementById('content_shipping'))
}
